var vue = new Vue({
	el: '.new-post-form',
	data: {
		file_type: 'pdf'
	}
});